<template>
  <div class="page-wrap" style="margin-top:0;">
    <div class="top-area">
      <div class="top-title fcf flex-center-between" id="topTitle">
        <div class="flex">
          <div class="flex-center fcf fw fz16">
            <img class="" style="width: 100px" src="@/assets/logo_white_z.png" alt/>
            <!--            <img class="image-logo mr5" src="@/assets/logo-white.png" alt />-->
            <!--            <span>{{baseName}}</span>-->
          </div>
          <!--          <header-menu />-->
        </div>
        <div class="flex fz14">
          <!--          <div class="button-login mr15 button-common" @click="customerEnterpriseLogin">刻企登录</div>-->
          <div class="button-login mr15 button-common" @click="login">登录</div>
          <div class="button-register button-common fcf" @click="register">注册</div>
        </div>
      </div>
      <div class="center-title fcf">
        <div class="fz40 fw mb15">{{ baseName }}</div>
        <div class="center-subtitle">
          全国互通 安全可信 公安备案
        </div>
      </div>
    </div>
    <div class="fun-content flex-center-between">
      <div
          :class="['fun-item pointer',item.path ? '' : 'func-disable']"
          v-for="(item, index) in funData"
          @click="onAction(item.value)"
          :key="index"
      >
        <img v-if="!item.path" class="func-building" src="../../assets/home/ic_building.png">
        <div class="fun-item-title flex-center mb15">
          <img class="fun-icon mr10" :src="item.url" alt/>
          <div class="fz18 fc3 fun-title">{{ item.title }}</div>
        </div>
        <div class="fun-item-sub fz14 fc9">{{ item.subTitle }}</div>
      </div>
    </div>
    <div class="policy-area">
      <div class="ta-c fw fz30">政策法规</div>
      <div class="top-tabs mb10 flex-center-between">
        <div class="left-tabs fz18 flex">
          <div
              @click="onClickTab('policy')"
              class="tab-item mr10"
              :class="activeName == 'policy' ? 'tab-item-active' : 'tab-item-inactive'"
          >
            政策
          </div>
          <div
              @click="onClickTab('rule')"
              class="tab-item"
              :class="activeName == 'rule' ? 'tab-item-active' : 'tab-item-inactive'"
          >
            法规
          </div>
        </div>
        <div class="more flex-center">
          <span class="fz14 fc-theme pointer">更多</span>
          <img class="icon-more" src="@/assets/home/icon-more.png" alt/>
        </div>
      </div>
      <div class="news-content">
        <div
            class="news-item flex-center-between"
            v-for="(item, index) in newsData"
            :key="index"
            @click="handleNewsClick(item)"
        >
          <div class="item-title flex-center fz14 fc0">
            <div class="circle mr10"></div>
            <div class="title">{{ item.noticeTitle }}</div>
          </div>
          <div class="item-date fz14 fc9">
            {{ $moment(item.createTime).format("YYYY-MM-DD") }}
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-area">
      <div class="title mb20">{{ baseName }}</div>
      <div class="handle-content flex-r-between">
        <div
            class="handle-item"
            v-for="(item, index) in handleData"
            :key="index + 'handle'"
        >
          <div class="flex-center mb20">
            <div v-show="index != 0" class="front-line item-line"></div>
            <div v-show="index == 0" class="item-empty"></div>
            <img class="item-img" :src="item.url" alt/>
            <div v-show="index != handleData.length - 1" class="behind-line item-line">
              <img class="icon-next" src="@/assets/home/icon-next.png" alt/>
            </div>
            <div v-show="index == handleData.length - 1" class="item-empty"></div>
          </div>
          <div class="fz18 fc3 w100 flex-dir-center">
            <div class="text-content mb15">
              <span class="mr5">{{ item.step }}</span>
              <span>{{ item.title }}</span>
            </div>
            <div class="fc9 fz14 text-content">{{ item.desc }}</div>
          </div>
        </div>
      </div>
    </div>
    <Bottom></Bottom>
  </div>
</template>
<script>
import Bottom from "@/components/Bottom.vue";
import HeaderMenu from "@/pages/home/components/header-menu.vue";

export default {
  components: {HeaderMenu, Bottom},
  data() {
    return {
      baseName: process.env.VUE_APP_API_BASE_NAME,
      funData: [
        {
          title: "广烁网签平台",
          value: 1,
          path: '/login',
          subTitle: "在线签署",
          url: require("@/assets/home/icon-search.png"),
        },
        {
          title: "单位公章在线申领",
          value: 3,
          path: '/register/physicsSeal',
          subTitle: "在线办理印章备案",
          url: require("@/assets/home/icon-seal.png"),
        },
        {
          title: "文件验真",
          value: 2,
          path: '/verifyTruth',
          subTitle: "验证签署文件有效性",
          url: require("@/assets/home/icon-iden.png"),
        },
        {
          title: "接入服务",
          value: 4,
          path: '/interfaceDocumentation',
          subTitle: "电子印章应用接入管理",
          url: require("@/assets/home/icon-assess.png"),
        },
        // {
        //   title: "刻企服务",
        //   value: 5,
        //   path: '/customerEnterprise/login',
        //   subTitle: "刻企电子印章申领管理",
        //   url: require("@/assets/home/icon-kq.png"),
        // },
      ],
      activeName: "policy",
      newsData: [],
      allData: [],
      handleData: [
        {
          step: "第一步",
          title: "企业注册登记",
          desc: "",
          url: require("@/assets/home/image-registration.png"),
        },
        {
          step: "第二步",
          title: "印章办理",
          desc: "",
          url: require("@/assets/home/image-processing.png"),
        },
        {
          step: "第三步",
          title: "缴费",
          desc: "",
          url: require("@/assets/home/image-payment.png"),
        },
        {
          step: "第四步",
          title: "申领发票",
          desc: "",
          url: require("@/assets/home/image-invoice.png"),
        },
        {
          step: "第五步",
          title: "授权使用",
          desc: "",
          url: require("@/assets/home/image-authorization.png"),
        },
      ],
    };
  },
  mounted() {
    // var topTitle = document.getElementById('topTitle')
    // topTitle.addEventListener('mouseover', function(e) {
    //   // 鼠标移入元素时触发的代码
    //   topTitle.style.backgroundColor = "#FFFFFF";
    //   topTitle.style.color = "#000000";
    // });
    //
    //
    // topTitle.addEventListener('mouseleave', function(e) {
    //   // 鼠标移出元素时触发的代码
    //   topTitle.style.backgroundColor = "";
    //   topTitle.style.color = "#FFFFFF";
    // });
    this.loadData();
  },
  methods: {
    loadData() {
      this.$http.get(this.$api.home.list).then((res) => {
        if (res.data.code == 200) {
          this.allData = res.data.data;
          this.newsData = res.data.data.policy;
        }
      });
    },
    handleNewsClick(item) {
      this.$router.push('/notice/detail/' + item.noticeId)
    },
    onClickTab(tab) {
      this.activeName = tab;
      if (tab == "policy") {
        this.newsData = this.allData.policy;
      } else {
        this.newsData = this.allData.statute;
      }
    },
    login() {
      // this.$router.push({
      //     path: "/login",
      // });
      window.location.href = 'http://sign.lngsyz.com/#/login'
    },
    customerEnterpriseLogin() {
      this.$router.push({
        path: "/customerEnterprise/login",
      });
    },
    register() {
      window.location.href = 'http://sign.lngsyz.com/#/register'
    },
    onAction(value) {
      if (value == 3) {
        this.$router.push({
          path: "/register/sealChange",
        });
      } else if (value == 1) {
        window.location.href = 'http://sign.lngsyz.com/#/login'
      } else if (value == 2) {
        this.$router.push({
          path: "/verifyTruth",
        });
      } else if (value == 4) {
        this.$router.push({
          path: "/interfaceDocumentation",
        });
      } else if (value == 5) {
        this.$router.push({
          path: "/customerEnterprise/login",
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.page-wrap {
  .top-area {
    width: 100%;
    height: 660px;
    //padding: 20px;
    box-sizing: border-box;
    background: url("../../assets/home/bg.png") no-repeat;
    background-position: center center;
    background-size: cover;
    box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.05);

    .top-title {

      padding: 20px;

      .image-logo {
        width: 16px;
        height: 16px;
      }

      .button-common {
        padding: 6px 25px;
        border-radius: 4px;
        cursor: pointer;
      }

      .button-login {
        background: #fff;
        color: #2c4fa5;
        border: 1px solid #2c4fa5;
      }

      .button-register {
        border: 1px solid #cccccc;
        box-shadow: 0px 1px 4px 0px #7d86f4;
      }
    }

    .center-title {
      margin-top: 180px;
    }

    .center-title .fw {
      font-size: 56px;
      font-weight: 500;
      letter-spacing: 3px;
      white-space: nowrap;
    }

    .center-subtitle {
      letter-spacing: 48px;
      font-weight: 500;
      font-size: 36px;
      margin-top: 40px;
      white-space: nowrap;
    }
  }

  .fun-content {
    padding: 0 150px;
    transform: translateY(-50%);

    .fun-item {
      border-radius: 6px;
      padding: 20px;
      background: #fff;
      width: 23%;
      min-width: 220px;
      box-shadow: 0px 4px 10px 0px #7d86f44c;
      position: relative;

      .func-building {
        right: 0;
        top: 0;
        position: absolute;
      }

      .fun-icon {
        width: 20px;
        height: 20px;
      }

      .fun-item-sub {
        text-align: left;
        margin-left: 26px;
      }
    }

    .func-disable {
      .fun-title {
        color: #c0c4cc;
      }

      .fun-item-sub {
        color: #c0c4cc;
      }
    }
  }

  .policy-area {
    padding: 0px 150px 20px;

    .top-tabs {
      .tab-item {
        width: 72px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        cursor: pointer;
      }

      .tab-item-active {
        border-bottom: 4px solid #1947c2;
        color: #1947c2;
      }

      .tab-item-inactive {
        border-bottom: none;
        color: #333;
      }

      .more {
        .icon-more {
          width: 16px;
          height: 16px;
        }
      }
    }

    .news-content {
      width: 100%;

      .news-item {
        width: 100%;
        height: 48px;
        line-height: 48px;
        border-bottom: 1px solid #f1f1f1;

        .item-title {
          width: 75%;
          cursor: pointer;
        }

        .title {
          width: 100%;
          text-align: left;
          white-space: nowrap; /* 防止文本换行 */
          overflow: hidden; /* 隐藏超出容器的文本 */
          text-overflow: ellipsis; /* 显示省略号代替被裁剪的文本 */
        }

        .circle {
          width: 6px;
          height: 6px;
          border-radius: 50%;
          border: 1px solid #000;
        }
      }
    }
  }

  .bottom-area {
    width: 100%;
    padding: 55px 125px 80px;
    background: #6c86e719;

    .title {
      color: #333333;
      font-size: 30px;
      text-align: center;
    }

    .handle-content {
      .handle-item {
        width: 20%;
        min-width: 230px;

        .text-content {
          width: 200px;
        }

        .item-img {
          width: 108px;
          height: 108px;
        }

        .item-line {
          position: relative;
          width: calc(50% - 53px);
          height: 1px;
          background: #1947c2;
          opacity: 0.2;
        }

        .item-empty {
          width: calc(50% - 53px);
          height: 1px;
        }

        .icon-next {
          position: absolute;
          width: 16px;
          height: 16px;
          top: -8px;
          right: -8px;
        }
      }
    }
  }
}
</style>
